import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {InventoryConfig, Inventory} from "./inventory"

export const inventoryLoader = function (options = {}) {
    componentLoader(componentConfig(Inventory, InventoryConfig.componentTypeKey, InventoryConfig.baseHtmlClass), options);
};

